import { CXoneClient } from '@nice-devone/agent-sdk';
import type { UserInfo } from '@nice-devone/common-sdk';
import type { CXoneClientExtended } from './types';

/**
 * Decode JWT token to extract tenant information
 */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(payload);
  } catch {
    return null;
  }
}

/**
 * Extract UserInfo from JWT payload for ACDSessionManager
 */
export function extractUserInfoFromJwt(jwtPayload: Record<string, unknown>): UserInfo {
  return {
    tenantId: (jwtPayload.tenantId as string) || '',
    tenant: (jwtPayload.tenant as string) || '',
    icAgentId: String(jwtPayload.icAgentId || ''),
    icBUId: String(jwtPayload.icBUId || ''),
    userName: (jwtPayload.name as string) || '',
    icClusterId: (jwtPayload.icClusterId as string) || '',
    userId: (jwtPayload.sub as string) || '',
    firstName: (jwtPayload.given_name as string) || '',
    lastName: (jwtPayload.family_name as string) || '',
    teamId: jwtPayload.teamId as number | undefined,
  };
}

// Helper to get the extended client
export function getExtendedClient(): CXoneClientExtended {
  return CXoneClient.instance as unknown as CXoneClientExtended;
}
